/* eslint-disable react/prop-types */
import React from "react";
import { Table, Header } from "semantic-ui-react";
import { getTimeLabel } from "../NewTable/utils";

// Styles
import styles from "./styles.module.css";

const NewTablePrint = (props) => {
	const { header, body, footer, printHeader } = props;
	const getPageMargins = () => {
		return `@page { margin: 20px 20px 20px 20px !important; }`;
	};
	return (
		<div className={styles.container}>
			<style>{getPageMargins()}</style>
			<div className={styles.containerCenter}>
				<Header as="h2" icon>
					<span className={styles.titleText}>{printHeader.company}</span>
					<Header.Subheader>{printHeader.title}</Header.Subheader>
				</Header>
			</div>
			<div className={styles.containerLeft}>
				<span className={styles.headerTitle}>Usuario:</span>
				{printHeader.user}
			</div>
			<div className={styles.containerLeft}>
				<span className={styles.headerTitle}>Fecha:</span> {getTimeLabel(String(new Date()), false, false, true)}
			</div>
			<div className={styles.tableContainer}>
				<Table sortable celled striped>
					{header()}
					{body()}
					{footer()}
				</Table>
			</div>
		</div>
	);
};

export default NewTablePrint;
